import request from '@/utils/request'
const serivceBase = require('@/config/serviceConfig')
// 百度
// 获取验证码
export function getCaptcha(data) {
  return request({
    url: `${serivceBase.SHIP}/baiDuH5/getCaptcha`,
    method: 'post',
    data
  })
}
// 检验兑换码-获取token
export function baiduCheck(data) {
  return request({
    url: `${serivceBase.SHIP}/baiDuH5/check`,
    method: 'post',
    data
  })
}
// 兑换领取
export function exchangeList(data) {
  return request({
    url: `${serivceBase.SHIP}/baiDuH5/exchange/${data.token}`,
    method: 'post',
    data
  })
}
